import axios from "axios";
import {materialCloudServicesPath} from "../../../Constants";

const jobRestUrl = materialCloudServicesPath + '/user/job-metric-drilling-material'

export default class JobMetricDrilling {

    static async getJobMetricDrillingByMaterialId(materialId) {
        return axios.get(jobRestUrl + '/by-material-id-for-catalog'
            + '?materialId=' + materialId);
    }
}